import { Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, {
  Dispatch,
  ReducerAction,
  useEffect,
  useReducer,
  useState,
} from 'react';
import PreviewPanel from './Components/PreviewPanel';
import SetupPanel from './Components/SetupPanel';
import { NotationWidgetReducer } from './NotationWidgetReducer';
import {
  notationWidgetInitialState,
  INotationWidgetState,
} from './Interfaces/INotationWidgetState';
import { NotationWidgetMappingService } from './Services/NotationWidgetMappingService';
import { NotationWidgetService } from './Services/NotationWidgetService';
import { NotationWidgetActionType } from './Types/NotationWidgetActionType';

const useStyles = makeStyles({
  root: {},
});

export const NotationWidgetState = React.createContext(
  {} as INotationWidgetState,
);

export const NotationWidgetDispatch = React.createContext(
  {} as Dispatch<ReducerAction<typeof NotationWidgetReducer>>,
);

const NotationWidget = () => {
  const classes = useStyles();

  const [state, dispatch] = useReducer(
    NotationWidgetReducer,
    notationWidgetInitialState(),
  );

  useEffect(() => {
    NotationWidgetService.GetQuickNotationWidget().then(response => {
      dispatch({
        type: NotationWidgetActionType.SetIsLoading,
        value: true,
      });

      if (response) {
        dispatch({
          type: NotationWidgetActionType.SetInitialData,
          id: response.id ?? 0,
          institutionId: response.institutionId ?? 0,
          createdOn: response.createdOn ?? '',
          createdById: response.createdById ?? '',
          modifiedById: response.modifiedById ?? '',
          titleText: response.titleText,
          descriptionText: response.description,
          height: response.height,
          width: response.width,
          alertPermissions:
            NotationWidgetMappingService.mapQuickNotationToAlertPermission(
              response,
            ),
          updatePermissions:
            NotationWidgetMappingService.mapQuickNotationToUpdatePermission(
              response,
            ),
          encouragementPermissions:
            NotationWidgetMappingService.mapQuickNotationToEncouragementPermission(
              response,
            ),
        });
      }

      dispatch({
        type: NotationWidgetActionType.SetIsLoading,
        value: false,
      });
    });
  }, []);

  return (
    <>
      <NotationWidgetState.Provider value={state}>
        <NotationWidgetDispatch.Provider value={dispatch}>
          <Typography variant="h1">Notation Widget</Typography>
          <Grid container spacing={4}>
            <Grid item md={12} lg={6}>
              <SetupPanel />
            </Grid>
            <Grid item md={12} lg={6}>
              <PreviewPanel />
            </Grid>
          </Grid>
        </NotationWidgetDispatch.Provider>
      </NotationWidgetState.Provider>
    </>
  );
};

export default NotationWidget;
